module.exports = __webpack_public_path__ + "img/stayDispensing.3e1061a8.svg";